import { Component, OnInit, ViewEncapsulation, OnDestroy, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';
import { Subject } from 'rxjs';
import { startWith, takeUntil, switchMap } from 'rxjs/operators';
import { forEach } from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { BaseService } from 'app/_helpers/base/base.service';

@Component({
  selector: 'app-wg-sales-offers',
  templateUrl: './wg-sales-offers.component.html',
  styleUrls: ['./wg-sales-offers.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class WgSalesOffersComponent implements OnInit, OnDestroy, AfterViewChecked {

  salesOfferActivities: UntypedFormControl = new UntypedFormControl('this_month');
  salesOfferFilter = {} as any;
  saleOfferData: any;
  scheme = {} as any;

  private _unsubscribeAll: Subject<any>;

  constructor(
    private _translateService: TranslateService,
    private cdref: ChangeDetectorRef,
    private _gService: BaseService
  ) {
    this.scheme = {
      domain: ['#ebe723', '#e08216', '#5c84f1', '#24e3e0', '#32a852', '#b02e7a']
    };
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.salesOfferActivities.valueChanges
      .pipe(
        startWith('this_month'),
        takeUntil(this._unsubscribeAll),
        switchMap((range: string) => {
          return this._gService.post(`dashboard/activities_sales_offers?range=${range}`, this.salesOfferFilter, 'nodejs');
        })
      )
      .subscribe((data: any) => {
        if (data.sales.length) {
          forEach(data.sales, (value) => {
            value.name = value.name ? this._translateService.instant(value.name) : '';
          });
        }
        if (data.offers.length) {
          forEach(data.offers, (value) => {
            value.name = value.name ? this._translateService.instant(value.name) : '';
          });
        }
        if (data.saleOffer.length) {
          forEach(data.saleOffer, (value) => {
            value.name = value.name ? this._translateService.instant(value.name) : '';
          });
        }
        this.saleOfferData = data;
      });
  }

  ngAfterViewChecked(): void {
    this.cdref.detectChanges();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

}
